<template>
  <div class="filter-bar">
    <div class="filter-bar-fixed">
      <div class="filter-bar-select">
        <slot name="nav-left" />
        <div
          class="filter-bar-item"
          v-for="(item, index) in items"
          :key="index"
          @click="handleTabClick(index)"
          :class="{ active: index === showedFilterItem }"
          v-show="!item.hide"
        >
          {{ filterItemLabels[index] }}
          <icon
            name="qingsu-list-arrow-down"
            :class="{
              active: index === showedFilterItem
            }"
          />
        </div>
      </div>
      <div class="filter-bar-list-container">
        <transition name="fade" v-if="showedFilterItem !== -1">
          <div
            @touchstart="showedFilterItem = -1"
            class="filter-bar-mask"
          ></div>
        </transition>
        <div
          :class="{
            'filter-bar-list': true,
            'tag-list': item.type === 'tag',
            active: showedFilterItem === index
          }"
          v-for="(item, index) in items"
          :key="index"
        >
          <template v-if="item.type !== 'multiple'">
            <div
              v-for="(v, i) in item.child"
              :key="i"
              :class="[
                'filter-bar-list-item',
                'cols-' + cols,
                value[index] === v.key ? 'active' : ''
              ]"
              :style="
                theme && value[index] === v.key
                  ? { color: theme, borderColor: theme }
                  : ''
              "
              @click="setValue(index, v.key, v)"
              v-stat="'选择' + item.stat || v.label"
            >
              <span>{{ v.label }}</span>
            </div>
          </template>
          <template v-else>
            <div
              class="filter-bar-label-wrap"
              v-for="(labels, i) in item.child"
              :key="i"
            >
              <p class="label-title">{{ labels.title }}</p>
              <div class="label-list">
                <div
                  :class="[
                    'label-key',
                    { active: subValue[label.type] === label.key }
                  ]"
                  v-for="(label, _i) in labels.child"
                  :key="_i"
                  @click.stop="setValue(index, label, item.type)"
                  v-stat="'选择' + item.stat || v.label"
                >
                  {{ label.label }}
                </div>
              </div>
            </div>
            <div class="filter-bar-btn-wrap">
              <div
                class="filter-bar-btn"
                @click="
                  subValue = {
                    category: '0',
                    activity: ''
                  }
                "
              >
                重置
              </div>
              <div class="filter-bar-btn" @click="submit(index)">确定</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'filter-bar',
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    theme: {
      type: String,
      default: '#0b8bff'
    },
    cols: {
      type: Number,
      default: 4
    },
    isScroll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showedFilterItem: -1,
      subValue: {
        category: '0',
        activity: ''
      }
    }
  },
  mounted() {
    if (this.isScroll) {
      window.addEventListener('scroll', this._scroll, false)
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this._scroll, false)
  },
  computed: {
    filterItemLabels() {
      return this.value.map((v, i) => {
        if (!this.items[i]) return ''
        if (this.items[i].type !== 'multiple') {
          return this.items[i].child.find(item => item.key === v).label
        } else {
          return this.items[i].name
        }
      })
    }
  },
  methods: {
    reset() {
      const value_temp = JSON.parse(JSON.stringify(this.value))
      this.items.map((item, index) => {
        this.filterItemLabels[index] = item.child[0].label
        value_temp[index] = item.child[0].key
      })
      this.$emit('input', [...value_temp])
    },

    handleTabClick(index) {
      this.showedFilterItem = this.showedFilterItem === index ? -1 : index
      this.$emit('filterClick')
    },

    setValue(index, val, type) {
      const { value } = this
      console.log(index, val, type)

      if (type === 'multiple') {
        this.$set(this.subValue, val.type, val.key)
        console.log('multiple', this.subValue)
      } else {
        console.log('emit input')
        this.filterItemLabels[index] = type.label
        value[index] = val
        this.handleTabClick(index)
        this.$emit('input', [...value])
        this.$emit('itemClick', index, this.filterItemLabels)
      }
    },

    submit(index) {
      console.log('submit')
      this.value[index] = Object.assign({}, this.subValue)
      this.$emit('input', [...this.value])
      this.handleTabClick(index)
    },

    _scroll() {
      this.handleTabClick(-1)
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.filter-bar {
  $h: 100px;
  &-fixed {
    height: $h;
    //   position: fixed;
    //   width: 750px;
  }
  &-select {
    background: #fff;
    display: flex;
    position: relative;
  }
  &-item {
    flex: 1;
    height: $h;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    color: #566171;
    justify-content: left;
    padding-left: 30px;
    &.active {
      color: #ff745b;
    }
    i {
      font-size: 28px;
      color: #566171;
      transform: scale(0.6);
      margin-left: 15px;
      transition: transform 0.2s;
      &.active {
        color: #ff745b;
        transform: scale(0.6) rotate(180deg);
      }
    }
  }
  &-list-container {
    width: 750px;
    position: absolute;
    z-index: 999;
  }
  &-list {
    background: #fff;
    padding: 14px 16px 30px;
    position: absolute;
    width: 100%;
    // opacity: 0;
    transform: scaleY(0);
    box-sizing: border-box;
    transform-origin: top center;
    transition: transform 0.3s, opacity 0.3s;
    &.active {
      // opacity: 1;
      transform: scaleY(1);
      .filter-bar-list-item {
        transition: opacity 0.3s 0.2s;
        // visibility: visible;
        opacity: 1;
      }
    }
    &.tag-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .filter-bar-list-item {
        // border-radius: 8px;
        padding: 14px;
        box-sizing: border-box;

        span {
          height: 60px;
          border-radius: 30px;
          background: #f3f4f5;
          font-size: 24px;
          color: #6c798c;
          border: 1px solid transparent;
          line-height: normal;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        &.active {
          span {
            background: #ffefec;
            border: 2px solid #ff745b;
            font-size: 24px;
            color: #ff745b;
          }
        }

        &.cols-4 {
          flex: 0 0 25%;
        }
        &.cols-3 {
          flex: 0 0 33.33%;
        }
      }
    }
  }
  &-list-item {
    opacity: 0;
  }
  &-label-wrap {
    .label-title {
      font-size: 28px;
      line-height: 40px;
      padding: 32px 0 18px;
    }
    .label-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .label-key {
        &.active {
          color: #ff745b;
          border-color: #ff745b;
        }
        &:nth-of-type(4n + 1) {
          margin-left: 0;
        }
        &:nth-of-type(4n + 0) {
          margin-right: 0;
        }
        line-height: 60px;
        font-size: 28px;
        color: #999;
        text-align: center;
        border-radius: 8px;
        margin: 14px 15px;
        box-sizing: border-box;
        border: 1px solid #eaeaea;
        width: 150px;
      }
    }
  }
  &-btn-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 48px;
    .filter-bar-btn {
      color: #fff;
      height: 80px;
      line-height: 80px;
      border-radius: 10px;
      text-align: center;
      font-size: 32px;
      &:nth-of-type(1) {
        width: 200px;
        background-color: #ccc;
      }
      &:nth-of-type(2) {
        margin-left: 30px;
        width: 460px;
        background-color: #ff745b;
      }
    }
  }
  &-mask {
    opacity: 1;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    width: 100%;
  }
}
</style>
